export interface BoWebRuntimeConfig {
  apiBaseUrl: string;
}

const CONFIG_PATH = '/config/bo-web.json';

let runtimeConfig: BoWebRuntimeConfig | undefined;
let loadPromise: Promise<BoWebRuntimeConfig> | null = null;

function parseApiBaseUrl(value: unknown): string {
  if (typeof value !== 'string') {
    throw new Error('BO runtime 設定缺少 apiBaseUrl');
  }
  const trimmed = value.trim();
  if (!trimmed) {
    throw new Error('BO runtime 設定缺少 apiBaseUrl');
  }

  const url = new URL(trimmed);
  if (url.protocol !== 'https:') {
    throw new Error('BO runtime 設定的 apiBaseUrl 必須是 HTTPS origin');
  }
  if (url.pathname !== '/' || url.search || url.hash) {
    throw new Error('BO runtime 設定的 apiBaseUrl 必須是純 origin');
  }

  return url.origin;
}

export function getRuntimeConfig(): BoWebRuntimeConfig {
  if (!runtimeConfig) {
    throw new Error('BO runtime 設定尚未初始化');
  }
  return runtimeConfig;
}

export function setRuntimeConfigForTest(
  config: BoWebRuntimeConfig | undefined
): void {
  runtimeConfig = config ? { ...config } : undefined;
  loadPromise = null;
}

export async function loadRuntimeConfig(
  configPath = CONFIG_PATH
): Promise<BoWebRuntimeConfig> {
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    runtimeConfig = undefined;
    const response = await fetch(configPath, {
      cache: 'no-store',
      credentials: 'same-origin',
    });
    if (!response.ok) {
      throw new Error('無法載入 BO runtime 設定');
    }

    const raw = (await response.json()) as Record<string, unknown>;
    runtimeConfig = {
      apiBaseUrl: parseApiBaseUrl(raw.apiBaseUrl),
    };
    return runtimeConfig;
  })();

  return loadPromise;
}
